import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "anabiya_admin_token_v1";

const Ctx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
  });
  const [me, setMe] = useState(null);   // null = checking, false = anon, obj = authed
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!token) { setMe(false); setReady(true); return; }
    axios
      .get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMe(r.data))
      .catch(() => { localStorage.removeItem(KEY); setToken(""); setMe(false); })
      .finally(() => setReady(true));
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem(KEY, data.token);
    setToken(data.token);
    setMe({ email: data.email, role: data.role, ok: true });
    return data;
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setToken("");
    setMe(false);
  };

  const authAxios = () => axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } });

  return (
    <Ctx.Provider value={{ token, me, ready, login, logout, authAxios }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAdminAuth = () => {
  const c = useContext(Ctx);
  if (!c) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return c;
};
